module.exports = __webpack_public_path__ + "img/aboservice-v2.899db796.jpg";